import React, { useMemo, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useQuery } from '@apollo/client';
import { string } from 'prop-types';
import { IfScope } from '@playbookux/playbook-web-core';
import ProjectCard from '../project-card';
import UploadButton from '../upload-button';
import AttachmentFile from '../attachment-file';
import {
  ButtonContainer,
  Error,
  Container,
  Loader,
} from './styles';
import Uploader from '../uploader';
import { GET_PROJECT_ATTACHMENTS } from './graphql';

const Attachments = ({ scope }) => {
  const [isUploaderOpen, setIsUploaderOpen] = useState(false);
  const { projectId } = useParams();

  const {
    data,
    loading,
    error,
    refetch,
  } = useQuery(GET_PROJECT_ATTACHMENTS,
    {
      variables: { projectId },
      skip: !projectId,
      fetchPolicy: 'network-only',
    });

  const handleOpenUploader = () => {
    setIsUploaderOpen(true);
  };

  const handleCloseUploader = () => {
    setIsUploaderOpen(false);
  };

  const files = useMemo(() => data?.projectAttachments || [], [data]);

  return (
    <>
      <ProjectCard title="Attachments">
        {
          loading && (
            <Loader />
          )
        }
        {
          error && (
            <Error>
              Error loading attachments:
              {' '}
              {error.message}
            </Error>
          )
        }
        {
          files && (
            <>
              <Container>
                {files.map((file) => (
                  <AttachmentFile
                    key={file.id}
                    file={file.filename}
                    filePath={file.filePath}
                    projectId={projectId}
                    id={file.id}
                    refetch={refetch}
                  />
                ))}
              </Container>
              <IfScope user scope={scope}>
                <ButtonContainer>
                  <UploadButton
                    text="Add an attachment"
                    handleOpenUploader={handleOpenUploader}
                  />
                </ButtonContainer>
              </IfScope>
            </>
          )
        }
      </ProjectCard>
      {isUploaderOpen && (
        <Uploader
          title="Upload file"
          onClose={handleCloseUploader}
          projectId={projectId}
          show={isUploaderOpen}
          uploadAttachment
        />
      )}
    </>
  );
};

Attachments.propTypes = {
  scope: string.isRequired,
};

export default Attachments;
